export default "__VITE_ASSET__DT_IA0Yi__"